import { render } from "./RiTutorial02.vue?vue&type=template&id=cf285d26"
import script from "./RiTutorial02.vue?vue&type=script&lang=js"
export * from "./RiTutorial02.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiTutorial02.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf285d26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf285d26', __exports__)) {
    api.reload('cf285d26', __exports__)
  }
  
  module.hot.accept("./RiTutorial02.vue?vue&type=template&id=cf285d26", () => {
    api.rerender('cf285d26', render)
  })

}


export default __exports__